import "./App.css";
import "./styles/ButtonSystem.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { AnalyticsScripts } from "./components/AnalyticsScripts";
import { HomeCMS } from "./pages/HomeCMS";
import { Episodes } from "./pages/Episodes";
import { EpisodeDetail } from "./pages/EpisodeDetail";
import { Hosts } from "./pages/Hosts";
import { Guests } from "./pages/Guests";
import { GuestDetail } from "./pages/GuestDetail";
import { Membership } from "./pages/Membership";
import { Contact } from "./pages/Contact";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import { ClubhouseLogin } from "./pages/ClubhouseLogin";
import { ClubhouseRegister } from "./pages/ClubhouseRegister";
import { ClubhouseForgotPassword } from "./pages/ClubhouseForgotPassword";
import { ClubhouseResetPassword } from "./pages/ClubhouseResetPassword";
import { ClubhouseDashboard } from "./pages/ClubhouseDashboard";
import { ClubhouseMembers } from "./pages/ClubhouseMembers";
import { ClubhouseLeaderboards } from "./pages/ClubhouseLeaderboards";
import { MemberLocker } from "./pages/MemberLocker";
import LinkHub from "./pages/LinkHub";
import Unsubscribe from "./pages/Unsubscribe";
import { AccountDeleted } from "./pages/AccountDeleted";
import { MemberRecover } from "./pages/MemberRecover";
import { API_URL } from './utils/apiUrl';



function App() {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    // Fetch analytics settings on app load
    const fetchAnalytics = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/cms/settings`);
        setAnalytics(response.data.analytics);
      } catch (error) {
        console.error('Error fetching analytics settings:', error);
      }
    };
    fetchAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsScripts analytics={analytics} />
        <ScrollToTop />
        <Routes>
          {/* Admin routes without Navigation/Footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          
          {/* Link Hub routes without Navigation/Footer (standalone) */}
          <Route path="/links/:slug" element={<LinkHub />} />
          
          {/* Unsubscribe page (standalone, no nav) */}
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          
          {/* Account deletion/recovery pages (standalone, no nav) */}
          <Route path="/account-deleted" element={<AccountDeleted />} />
          <Route path="/member/recover" element={<MemberRecover />} />
          <Route path="/member/recover/confirm" element={<MemberRecover />} />
          
          {/* Clubhouse routes without Navigation/Footer */}
          <Route path="/clubhouse/login" element={<ClubhouseLogin />} />
          <Route path="/clubhouse/register" element={<ClubhouseRegister />} />
          <Route path="/clubhouse/forgot-password" element={<ClubhouseForgotPassword />} />
          <Route path="/clubhouse/reset-password" element={<ClubhouseResetPassword />} />
          <Route path="/clubhouse/dashboard" element={<ClubhouseDashboard />} />
          <Route path="/clubhouse/members" element={<ClubhouseMembers />} />
          <Route path="/clubhouse/leaderboards" element={<ClubhouseLeaderboards />} />
          <Route path="/clubhouse/locker" element={<MemberLocker />} />
          
          {/* Public routes with Navigation/Footer */}
          <Route path="*" element={
            <>
              <Navigation />
              <Routes>
                <Route path="/" element={<HomeCMS />} />
                <Route path="/episodes" element={<Episodes />} />
                <Route path="/episodes/:slug" element={<EpisodeDetail />} />
                <Route path="/hosts" element={<Hosts />} />
                <Route path="/guests" element={<Guests />} />
                <Route path="/guests/:id" element={<GuestDetail />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
